
<template>
<!-- 模板设置 -->
  <div class="modal-template-setting">
    <el-dialog
      title="模板设置"
      :visible.sync="dialogVisible"
      custom-class="dialog_template_setting"
      width="40%">
      <el-form :model="formdata" :rules="rules" ref="ruleForm">
        <el-form-item label="模板名称: " :label-width="formLabelWidth" prop="acCardName">
          <el-input v-model="formdata.acCardName" autocomplete="off" maxlength=50 show-word-limit style="width: 300px !important"></el-input>
        </el-form-item>
        <el-form-item label="学段: " :label-width="formLabelWidth" prop="Period">
          <el-select v-model="formdata.Period" placeholder="请选择学段">
            <el-option
              v-for="item in kMAndPeriod.Period"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科目: " :label-width="formLabelWidth" prop="KmCode">
          <el-select v-model="formdata.KmCode" placeholder="请选择科目">
            <el-option
              v-for="item in kMAndPeriod.KM"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel('cancel')">取 消</el-button>
        <el-button type="primary" @click="handleSubmit('ruleForm')" :loading="btnLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AcCardApi from "@/services/acCard"
import { mapState, mapMutations } from "vuex";
export default {
  props:{
    open: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
  ...mapState("card", {
    kMAndPeriod: (state) => state.kMAndPeriod, //学科和学段的字典
    }),
  },
  data() {
    return {
      formLabelWidth: '160px',
      dialogVisible: false,
      formdata: {
        acCardGuid: 0,
        acCardName: '', // 模板名称
        Period: 0, // 学段
        KmCode: 0, // 科目
      },
      rules: {
        acCardName: [
            { required: true, message: '请输入答题卡名称', trigger: 'blur' },
            // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
          ],
        Period: [
          { required: true, message: '请选择学段', trigger: 'change' }
        ],
        KmCode: [
          { required: true, message: '请选择科目', trigger: 'change' }
        ],
      },
      btnLoading: false
    }
  },
  methods: {
    handleSubmit(formName) {
       this.$refs[formName].validate(async (valid) => {
         if(valid) {
           this.btnLoading = true;
           const result = await AcCardApi.EditTemplateType(this.formdata)
           if(result.status == 200) {
             this.$message({
               message: '操作成功~',
               type: 'success'
             });
           } else {
            //  this.$message({
            //    message: result.message,
            //    type: 'error'
            //  });
           }
           this.btnLoading = false;
           this.dialogVisible = false;
         } 
       })
    },
    handleCancel(name) {
      if(name == 'cancel') {
        this.dialogVisible = false;
        this.$emit('onChange', 'cancel');
      } else {
        this.dialogVisible = false;
      }
    }
  },
  watch: {
    open(newVal) {
      if(newVal) {
        this.dialogVisible = true;
      }
    },
    dialogVisible(newVal) {
      if(!newVal) {
        this.$emit('onChange', newVal);
      } else {
        // this.formdata.Period = this.kMAndPeriod.Period[0].value;
        // this.formdata.KmCode = this.kMAndPeriod.KM[0].value;
      }
    },
    params(newVal) {
      if(newVal) {
        this.formdata.acCardName = newVal.Name;
        this.formdata.acCardGuid = newVal.AcCardGuid;
        this.formdata.Period = Number(newVal.Periodid);
        this.formdata.KmCode = Number(newVal.kmid);
      }
    }
  }
}
</script>

<style lang="scss" >
.modal-template-setting{
.el-select .el-input{
  width: 300px !important;
}
}
.dialog_template_setting{
.el-form-item span{
  padding: 0;
  line-height: 26px !important;
}

.el-input__suffix{
  right: -50px !important;
}
}
</style>